import { useEffect, useState } from 'react'
import { Box, Skeleton } from '@chakra-ui/react'
import { convertFromRaw, EditorState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg'

const LazyImageBlock = ({ block, contentState }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const { src, alignment } = contentState.getEntity(block.getEntityAt(0)).getData()
  let imgAlignment = 'center'

  if (alignment === 'left') {
    imgAlignment = 'flex-start'
  }

  if (alignment === 'right') {
    imgAlignment = 'flex-end'
  }

  useEffect(() => {
    if (src.includes(';base64,')) {
      setImageLoaded(true)
    } else {
      setImageLoaded(false)
    }
  }, [src])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: imgAlignment
      }}
    >
      <Skeleton
        isLoaded={imageLoaded}
        fadeDuration={1}
      >
        <img
          src={src}
          alt="content"
          onLoad={() => setImageLoaded(true)}
          style={{
            width: imageLoaded ? 'auto' : '70svw',
            height: imageLoaded ? 'auto' : '120px'
          }}
        />
      </Skeleton>
    </div>
  )
}

const blockRendererFn = (block) => {
  if (block.getType() === 'atomic') {
    return {
      component: LazyImageBlock,
      editable: false
    }
  }
  return null
}

export const TextEditorReader = ({
  dispatch,
  item,
  widen,
  setCloseAllDrawers
}) => {
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty())
  const [firstBlockText, setFirstBlockText] = useState('')

  const customLinkClick = () => {
    const editorLinks = document.querySelectorAll('.public-DraftStyleDefault-block a')

    if (editorLinks) {
      editorLinks.forEach((link) => {
        const href = link.getAttribute('href')

        if (href.startsWith(window.location.origin + '/?id=')) {
          const hrefId = href.split('/?id=')[1]

          link.addEventListener('click', (e) => {
            e.stopPropagation()
            e.preventDefault()

            if ((window.location.href).split('/?id=')[1] !== hrefId) {
              dispatch(setCloseAllDrawers(true))
              const customPopupOverlay = document.querySelector('#custom-popup-overlay')
              if (customPopupOverlay) {
                customPopupOverlay.click()
              }

              setTimeout(() => {
                dispatch(setCloseAllDrawers(false))

                const event = new CustomEvent('custom-chat-show_on_map', {
                  detail: {
                    jid: hrefId + '-'
                  }
                })
                window.dispatchEvent(event)
              }, 850)
            }
          })
        } else {
          link.setAttribute('target', '_blank')
          link.setAttribute('rel', 'noopener noreferrer')
        }
      })
    }
  }

  useEffect(() => {
    if (item.body) {
      const raw = { ...item.body }
      const firstBlock = raw.blocks[0]
      const lastBlock = raw.blocks[raw.blocks.length - 1]
      setFirstBlockText(firstBlock.text)

      if (
        firstBlock
        && firstBlock.type === 'unstyled'
        && firstBlock.text.trim() === ''
      ) {
        raw.blocks = raw.blocks.slice(1)
      }

      if (
        lastBlock
        && lastBlock.type === 'unstyled'
        && lastBlock.text.trim() === ''
      ) {
        raw.blocks = raw.blocks.slice(0, -1)
      }

      const contentState = convertFromRaw(raw)
      setEditorState(EditorState.createWithContent(contentState))

      setTimeout(() => customLinkClick(), 500)
    }
  }, [item.body])

  return (
    <Box>
      <Editor
        editorState={editorState}
        blockRendererFn={blockRendererFn}
        readOnly
        toolbarHidden
        editorStyle={{
          fontSize: widen ? '22px' : '16px',
          transition: 'font-size 0.8s',
          paddingTop: firstBlockText === '' ? '30px' : 0
        }}
      />
    </Box>
  )
}
